export const Classes = (() => {
	'use strict';

	function init() {
		if($('.gform_confirmation_wrapper ').length){
			$([document.documentElement, document.body]).animate({
				scrollTop: $(".gform_confirmation_wrapper").offset().top + 100
			}, 0);
		}


		$(document).ready(function(){
			$('.class-block').each(function( i ) {
				// if();
				// classes upcoming or within hour
				let availableClass = $(this).find('.date.pxblock--classes__course-date').not( ".pxblock--classes__course--past" ).length;

				let hourLeftClass = $(this).find('.class-hour-left').length;
				// fugure classes not within hour
				let hourLeftFuture = $(this).find('.class-hour-future').length;
				
				console.log(hourLeftFuture)

				if(hourLeftClass == 1){
					$(this).addClass('last-hour-class');
				}

				if(availableClass >= 1){
					if( hourLeftFuture == 1){
						if(hourLeftClass >= 1){
							$(this).find('.pxblock--classes__course-form').html('Registration for this class is closed at this time.');
						}
					}
				}


			});
		});

	}

	return {
		init: init, 
		name: 'classes'
	};
})();
